import { useState } from "react";
import "../css/CheckBox.css";
import { inputOnEnter } from "../js/utils";

export default function CheckBox({
  onClick = () => {},
  ttId,
  radio,
  active,
  disabled,
  onMouseEnter,
  onMouseLeave,
  tabIndex,
}) {
  const [isInputFocused, setIsInputFocused] = useState(false);

  const handleKeyDown = (event) => {
    if (event.key === " " && !disabled) {
      onClick();
    }
  };

  const handleInputFocus = () => {
    setIsInputFocused(true);
  };

  const handleInputBlur = () => {
    setIsInputFocused(false);
  };

  return (
    <button
      type="button"
      data-tooltip-id={ttId}
      className={`checkbox-container ${
        radio ? "checkbox-container-radio" : ""
      } ${active ? "checkbox-selected" : "checbox-inactive"} ${
        disabled ? "checkbox-disabled" : ""
      }`}
      disabled={disabled}
      onClick={() => {
        if (!disabled) onClick();
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <input
        className={`checkbox-input ${
          isInputFocused ? "checkbox-input-focused" : ""
        }`}
        tabIndex={disabled ? -1 : tabIndex}
        type="text"
        autoComplete="nope"
        disabled={disabled}
        onKeyUp={inputOnEnter}
        onKeyDown={handleKeyDown}
        onFocus={handleInputFocus}
        onBlur={handleInputBlur}
      ></input>
      {active && !radio && (
        <img
          src="/images/checkbox-selected.svg"
          loading="lazy"
          alt="Icon"
          className="selected-img"
        />
      )}
    </button>
  );
}
